<form [formGroup]="workOrderSearchTextForm">
  <div>
    <mc-input
      hiddenlabel
      placeholder="Search for a Shop Code"
      fit="small"
      ngDefaultControl
      formControlName="searchText"
      (keyup.enter)="applySearchTextFilters()"
      icon="magnifying-glass"
      [clearbutton]="true"
      (clearbuttonclick)="applySearchTextFilters()"
      [attr.invalid]="isControlInErrorState(this.workOrderSearchTextForm.controls.searchText)">
      @if (this.workOrderSearchTextForm.controls.searchText.hasError('pattern')) {
        <span slot="errormessage">Incorrect Shop Code</span>
      }
    </mc-input>
  </div>
</form>
